import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { BulkActionsContactsChangedArgs } from '..';

interface ComponentArgs {
  contactIds: string[];
  onContactsChanged: (args: BulkActionsContactsChangedArgs) => void;
  onClose: () => void;
}

export default class ContactBulkActionsEditPropertyIndexComponent extends Component<ComponentArgs> {
  @tracked stage: 'ask' | 'new' | 'edit' = 'ask';
  @tracked existingPropertyName?: string;

  @action
  handleOnAddNewProperty() {
    this.stage = 'new';
  }

  @action
  handlePropertySelected(propertyName: string) {
    this.stage = 'edit';
    this.existingPropertyName = propertyName;
  }
}
